import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper";
import "./styles.css";
import { Slide1 } from "./Slides/Slide1";
import { Slide2 } from "./Slides/Slide2";
import { Slide3 } from "./Slides/Slide3";

export const Slider = () => {
  return (
    <div className="navigation-wrapper" id="about">
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        spaceBetween={50}
        slidesPerView={1}
      >
        <SwiperSlide>
          <Slide1 />
        </SwiperSlide>
        <SwiperSlide>
          <Slide2 />
        </SwiperSlide>
        <SwiperSlide>
          <Slide3 />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};